import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppComponents, PrestoAppUtils } from 'presto-mini-apps-lib';
import PageWrapper from '../../components/PageWrapper';
import {
    PaymentType,
    PaymentGroupType,
    PaymentTypeInfo,
    isCreditCard, isPrestoPayMethod,
    isLoyaltyPayMethod,
    encryptData,
    ButtonHeight,
    PaymentMethodBlockHeight,
} from '../../constants/appState';
import {
    ErrorCode,
    LoyaltyInfoAccountStatus,
    PaymentStatus
} from '../../constants/statusCode';
import {
    phrase_PINErrorMessage,
    title_transactionPin,
    term_topUpUsing,
    term_topUp,
    TopUpMessages,
    term_useLoyaltyPoints,
    phrase_NoPaymentMethodAvailableTitle,
    phrase_NoPaymentMethodAvailableMessage,
    phrase_InsufficientBalance,
    title_selectedPayment,
    term_totalAmount,
    phrase_goRewardSeclected,
    phrase_goRewardCombinationMessage,
    phrase_LoyaltyInputOtp,
} from '../../constants/text';
import PaymentTypeSelector from '../../components/PaymentTypeSelector';
import connectPage from '../../scenes/Main';
import Routes from '../../constants/routes';
import { appService } from '../../services';
import DigitInputWithLabel from '../../components/DigitInputWithLabel';
import PoweredByPresto from '../../components/PoweredByPresto';
import LoyaltyTypeMultiSelector from '../../components/LoyaltyTypeMultiSelector';
import LoyaltyMessageModal from '../../components/LoyaltyMessageModal';
import HorizontalScroller from '../../components/HorizontalScroller';


class TopUpPayment extends Component {
    pageName;
    tickCount = 0;

    constructor(props) {
        super(props);

        this.pageName = Routes.TOPUP_PAYMENT;

        this.state = {
            paymentListData: [],
            loyaltyListData: [],
            onlineBankListData: [],
            isFormError: true,
            isFormTouched: false,
            clearField: false,
            form2FATryCount: 0,
            formValue: {
                paymentType: '',
                paymentTypeError: false,
                paymentTypeErrorMessage: '',
                pinNumber: '',
                pinNumberError: false,
            },
            otherPaymentMethod: [],
            loyaltyPaymentMethod: [],
            secondaryPaymentMethod: '',
            amountToPay: props.mainProps.appState.topUpData.amount,
            remainingAmount: 0,
            firstPaymentAmount: 0,
            loyaltyPaymentAmount: 0,
            allowShow3DSForm: false,
            isAuthRequired: false,
            goBackPage: Routes.TOPUP_OPTIONS,
            dialog: {
                show: false,
                title: '',
                message: '',
                onClose: null,
            }
        };

        this.scrollerRef = React.createRef();
        this.form3DSRef = React.createRef();
    }

    onErrorFallBackIcon = (e) => {
        e.target.onError = null;
        e.target.src = PrestoAppTheme.images.PaymentMethodDefaultIcon.src
    };

    componentDidMount() {
        const {
            mainProps,
        } = this.props;
        const topUpData = mainProps.appState.topUpData;

        let tempObj = {};
        let tempOnlineBankObj = [];
        let tempLoyaltyObj = [];

        let sortOrder = 1;
        let onlineBankInserted = false;
        topUpData.paymentCombinationList.forEach((item, key) => {
            const id = item.paymentMethod;
            const allowedPaymentInfo = PaymentTypeInfo[id] !== undefined ? PaymentTypeInfo[id] : null;

            if (item.groupType === PaymentGroupType.PRESTOPAY) {
                if (mainProps.appState.isGuest) {
                    tempObj[id] = {
                        id: PaymentType.PRESTOWALLET,
                        label: PaymentTypeInfo[PaymentType.PRESTOWALLET].label,
                        icon: PaymentTypeInfo[PaymentType.PRESTOWALLET].icon,
                        iconHover: PaymentTypeInfo[PaymentType.PRESTOWALLET].iconHover,
                        sortOrder: 0,
                        balance: 0
                    }
                } else {
                    tempObj[id] = {
                        id: id,
                        label: item.displayName,
                        icon: allowedPaymentInfo.icon,
                        iconHover: allowedPaymentInfo.iconHover,
                        sortOrder: sortOrder++,
                        balance: topUpData.userInfo[allowedPaymentInfo.balanceID]
                    }
                }
            } else if (item.groupType === PaymentGroupType.ONLINEBANK) {
                if (!onlineBankInserted) {
                    onlineBankInserted = true;
                    tempObj[PaymentType.ONLINEBANK] = {
                        id: PaymentType.ONLINEBANK,
                        label: 'Online Banking',
                        icon: <img
                            src={PrestoAppTheme.images.OnlineBankIcon.src}
                            alt='Online Banking' />,
                        iconHover: <img
                            src={PrestoAppTheme.images.OnlineBankIcon.src}
                            alt='Online Banking' />,
                        sortOrder: sortOrder++,
                        balance: 'n/a'
                    }
                }
                tempOnlineBankObj.push({
                    id: id,
                    label: item.displayName,
                    icon: <img src={item.imageUrl} alt={item.displayName} onError={this.onErrorFallBackIcon} />,
                    iconHover: <img src={item.imageUrl} alt={item.displayName} onError={this.onErrorFallBackIcon} />,
                    sortOrder: sortOrder++,
                    balance: 'n/a',
                    allowRedirect: true
                });
            } else if (id === PaymentType.CARD) {
                const cardPaymentList = topUpData.userInfo.availableCards;
                if (cardPaymentList.length > 0) {
                    const _primaryCard = cardPaymentList.filter(item => item.isPrimary);
                    const _nonPrimaryCard = cardPaymentList.filter(item => !item.isPrimary).sort((a, b) => a.displayName.localeCompare(b.displayName));
                    _primaryCard.forEach((item, key) => {
                        tempObj[PaymentType.CARD + '_' + key] = {
                            id: PaymentType.CARD + '_' + key,
                            label: item.displayName,
                            icon: PaymentTypeInfo[PaymentType.CARD].icon,
                            iconHover: PaymentTypeInfo[PaymentType.CARD].iconHover,
                            balance: 'n/a',
                            maskedCardNumber: item.maskedCardNum,
                            cardType: item.cardType,
                            cardProvider: item.cardProvider,
                            cardReference: item.cardRefNum,
                            isPrimary: item.primaryCard,
                            sortOrder: sortOrder++,
                        }
                    });
                    _nonPrimaryCard.forEach((item, key) => {
                        tempObj[PaymentType.CARD + '_' + key] = {
                            id: PaymentType.CARD + '_' + key,
                            label: item.displayName,
                            icon: PaymentTypeInfo[PaymentType.CARD].icon,
                            iconHover: PaymentTypeInfo[PaymentType.CARD].iconHover,
                            balance: 'n/a',
                            maskedCardNumber: item.maskedCardNum,
                            cardType: item.cardType,
                            cardProvider: item.cardProvider,
                            cardReference: item.cardRefNum,
                            isPrimary: item.primaryCard,
                            sortOrder: sortOrder++,
                        }
                    });
                }
            } else if (item.groupType === PaymentGroupType.LOYALTY) {
                const loyaltyInfo = topUpData.userInfo.loyaltyMethods.find((element) => {
                    return element.type === id;
                });
                if (loyaltyInfo !== null && loyaltyInfo !== undefined) {
                    tempLoyaltyObj.push({
                        id: loyaltyInfo.type,
                        loyaltyId: loyaltyInfo.type,
                        label: loyaltyInfo.title,
                        icon: <img src={item.imageUrl} alt={item.displayName} onError={this.onErrorFallBackIcon}/>,
                        iconHover: <img src={item.imageUrl} alt={item.displayName} onError={this.onErrorFallBackIcon}/>,
                        logo: <img src={item.bannerUrl} alt={item.displayName} onError={this.onErrorFallBackIcon}/>,
                        sortOrder: allowedPaymentInfo && allowedPaymentInfo.sortOrder ? allowedPaymentInfo.sortOrder: sortOrder++,
                        insufficientTitle: allowedPaymentInfo && allowedPaymentInfo.insufficientTitle ? allowedPaymentInfo.insufficientTitle : "Insufficient " + loyaltyInfo.unit,
                        insufficientMessage: allowedPaymentInfo && allowedPaymentInfo.insufficientMessage ? allowedPaymentInfo.insufficientMessage : "You have insufficient " + (loyaltyInfo.unit ? loyaltyInfo.unit.toLowerCase() : "points") + " for payment (minimum " + mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(+loyaltyInfo.minCents / 100) +").",
                        points: loyaltyInfo.balance,
                        balance: loyaltyInfo.value,
                        unit: loyaltyInfo.unit ? loyaltyInfo.unit : "Points",
                        maxRedeemablePoints: loyaltyInfo.maxRedeemablePoints,
                        maxRedeemableCents: loyaltyInfo.maxRedeemableCents,
                        minPoints: loyaltyInfo.minPoints,
                        minCents: loyaltyInfo.minCents,
                        rate: loyaltyInfo.rate,
                        memberId: loyaltyInfo.memberId,
                        accountStatus: loyaltyInfo.accountStatus,
                        transactionLimited: loyaltyInfo.transactionLimited,
                        mobileCountryCode: loyaltyInfo.otpLength > 0 ? topUpData.userInfo.mobileCountryCode : null,
                        mobileNum: loyaltyInfo.otpLength > 0 ? topUpData.userInfo.mobileNum : null,
                        otpLength: loyaltyInfo.otpLength,
                        otpMessage: loyaltyInfo.otpMessage ? loyaltyInfo.otpMessage : phrase_LoyaltyInputOtp,
                    });
                }
            } else {
                tempObj[id] = {
                    id: id,
                    label: item.displayName,
                    icon: <img src={item.imageUrl} alt={item.displayName} onError={this.onErrorFallBackIcon} />,
                    iconHover: <img src={item.imageUrl} alt={item.displayName} onError={this.onErrorFallBackIcon} />,
                    sortOrder: sortOrder++,
                    balance: 'n/a',
                    allowRedirect: true
                }
            }
        });

        var len = tempObj.length;
        const skipLogin = window.PrestoPayObj.hidePresto == true || len == 1;
        const sortedPaymentListData = this.sortPaymentList(tempObj, skipLogin);
        this.setState({
            paymentListData: sortedPaymentListData,
            onlineBankListData: tempOnlineBankObj,
            loyaltyListData: tempLoyaltyObj
        }, () => {
            this.onAutoAddLoyaltyMethod();
        });

        if (sortedPaymentListData.length == 0 && tempLoyaltyObj.length == 0) {
            this.setState({
                dialog: {
                    show: true,
                    title: phrase_NoPaymentMethodAvailableTitle,
                    message: phrase_NoPaymentMethodAvailableMessage,
                    onClose: this.onCloseDialogHandler
                }
            });
        }
    }

    onAutoAddLoyaltyMethod = () => {
        const { mainProps } = this.props;
        const topUpData = mainProps.appState.topUpData;

        const { loyaltyPaymentMethod, loyaltyPaymentAmount, paymentListData, loyaltyListData } = this.state;
        if (loyaltyListData && loyaltyListData.length > 0) {
            var newLoyaltyPaymentAmount = loyaltyPaymentAmount;
            var newLoyaltyPaymentMethod = loyaltyPaymentMethod;
            let remainingAmount = topUpData.amount;
            const selectedLoyaltyPaymentMethods = topUpData.loyaltyPaymentMethod || [];
            loyaltyListData.forEach(loyaltyItem => {
                const selectedLoyaltyPaymentMethod = selectedLoyaltyPaymentMethods.filter((item) => item.id === loyaltyItem.loyaltyId);
                const allowAutoAdd = (!topUpData.loyaltyPaymentMethod || (topUpData.loyaltyPaymentMethod.length > 0 && selectedLoyaltyPaymentMethod[0]));
                const redeemAmount = selectedLoyaltyPaymentMethod[0] ? selectedLoyaltyPaymentMethod[0].amount : remainingAmount;
                if (allowAutoAdd && LoyaltyInfoAccountStatus.NormalPrincipal === loyaltyItem.accountStatus 
                    && redeemAmount > 0 && loyaltyItem.maxRedeemableCents > 0 && loyaltyItem.minCents <= redeemAmount) {
                    let specifiedAmount = redeemAmount;
                    if (loyaltyItem.maxRedeemableCents <= specifiedAmount) {
                        specifiedAmount = loyaltyItem.maxRedeemableCents;
                    }
                    var specifiedPoints = Math.ceil(+specifiedAmount / +(loyaltyItem.rate));
                    
                    newLoyaltyPaymentAmount = newLoyaltyPaymentAmount + (+specifiedAmount);
                    newLoyaltyPaymentMethod.push({
                        id: loyaltyItem.loyaltyId,
                        amount: specifiedAmount,
                        points: specifiedPoints
                    });

                    remainingAmount = (remainingAmount - specifiedAmount) > 0 ? remainingAmount - specifiedAmount : 0;
                }
            });

            this.setState({
                loyaltyPaymentMethod: newLoyaltyPaymentMethod,
                loyaltyPaymentAmount: newLoyaltyPaymentAmount
            }, () => {
                const initialPaymentType = this.determineIntialPaymentType(paymentListData, remainingAmount);
                if (!!initialPaymentType) {
                    this.onSelectInputHandler(initialPaymentType);
                }
            });
        } else {
            const amount = topUpData.amount;
            const initialPaymentType = this.determineIntialPaymentType(paymentListData, amount);
            if (!!initialPaymentType) {
                this.onSelectInputHandler(initialPaymentType);
            }
        }
    }

    onToggleLoyaltyInputHandler = (loyaltyId) => {
        const loyaltyMethod = this.getSelectedLoyaltyArrayByID(loyaltyId);
        if (loyaltyMethod !== null && loyaltyMethod !== undefined) {
            this.onRemoveLoyaltyMethod(loyaltyId);
        } else {
            this.onAddLoyaltyMethod(loyaltyId, null);
        }
    };

    onRemoveLoyaltyMethod = (loyaltyId) => {
        const { mainProps } = this.props;
        const { formValue, loyaltyPaymentMethod, loyaltyPaymentAmount } = this.state;

        var newLoyaltyPaymentMethod = loyaltyPaymentMethod;
        var newLoyaltyPaymentAmount = loyaltyPaymentAmount;
        for (var i = 0; i < newLoyaltyPaymentMethod.length; i++) {
            if (newLoyaltyPaymentMethod[i].id === loyaltyId) {
                newLoyaltyPaymentAmount = newLoyaltyPaymentAmount - newLoyaltyPaymentMethod[i].amount;
                newLoyaltyPaymentMethod.splice(i, 1);
                i--;
            }
        }
        
        const paymentData = mainProps.appState.paymentData;
	    const isAuthRequiredForLoyalty = newLoyaltyPaymentMethod.some(item => {
	        const combination = paymentData.paymentCombinationList.find(combo => combo.paymentMethod === item.id);
	        return combination && combination.authRequired === true;
	    });
	    
	    const isAuthRequiredForPaymentType = paymentData.paymentCombinationList.some(combination => 
        	combination.paymentMethod === formValue.paymentType && combination.authRequired === true
   		 );
   		 
   	    const isAuthRequired = isAuthRequiredForLoyalty || isAuthRequiredForPaymentType;

        this.setState({
            loyaltyPaymentMethod: newLoyaltyPaymentMethod,
            loyaltyPaymentAmount: newLoyaltyPaymentAmount,
            isAuthRequired
        }, () => {
            this.onSelectInputHandler(formValue.paymentType);
        });
    };

    onAddLoyaltyMethod = (loyaltyId, specifiedAmount) => {
        const { mainProps } = this.props;
        const { formValue, loyaltyPaymentMethod, loyaltyPaymentAmount, paymentListData } = this.state;

        const loyaltyItem = this.getLoyaltyArrayByID(loyaltyId);

        var specifiedPoints = Math.ceil(+specifiedAmount / +(loyaltyItem.rate));
        var newLoyaltyPaymentAmount = loyaltyPaymentAmount + (+specifiedAmount);
        var newLoyaltyPaymentMethod = loyaltyPaymentMethod;

        let _arr = newLoyaltyPaymentMethod.filter(item => (item.id === loyaltyId));
        if (_arr.length > 0) {
            newLoyaltyPaymentAmount = newLoyaltyPaymentAmount - _arr[0].amount;
            _arr[0].amount = specifiedAmount;
            _arr[0].points = specifiedPoints;
        } else {
            newLoyaltyPaymentMethod.push({
                id: loyaltyId,
                amount: specifiedAmount,
                points: specifiedPoints
            });
        }
        
        const paymentData = mainProps.appState.paymentData;
	    const isAuthRequiredForLoyalty = newLoyaltyPaymentMethod.some(item => {
	        const combination = paymentData.paymentCombinationList.find(combo => combo.paymentMethod === item.id);
	        return combination && combination.authRequired === true;
	    });
	    
	    const isAuthRequiredForPaymentType = paymentData.paymentCombinationList.some(combination =>
	        combination.paymentMethod === formValue.paymentType && combination.authRequired === true
	    );
	    
	    const isAuthRequired = isAuthRequiredForLoyalty || isAuthRequiredForPaymentType;

        this.setState({
            loyaltyPaymentMethod: newLoyaltyPaymentMethod,
            loyaltyPaymentAmount: newLoyaltyPaymentAmount,
            isAuthRequired
        }, () => {
            let tngEWalletItem = paymentListData.filter(item => (item.id === PaymentType.TNGEWALLET));
            if (PaymentType.GOREWARDS === loyaltyId && tngEWalletItem.length > 0) {
                this.onSelectInputHandler(PaymentType.TNGEWALLET);
            } else {
                this.onSelectInputHandler(formValue.paymentType);
            }
        });
    };

    onRevalidateLoyaltyMethod  = (resp) => {
        const {
            loyaltyListData
        } = this.state;

        for (var i = 0; i < loyaltyListData.length; i++) {
            var loyaltyItem = loyaltyListData[i];
            if (loyaltyItem.id === resp.type) {
                loyaltyItem.points = resp.balance;
                loyaltyItem.balance = resp.value;
                loyaltyItem.maxRedeemablePoints = resp.maxRedeemablePoints;
                loyaltyItem.maxRedeemableCents = resp.maxRedeemableCents;
                loyaltyItem.minPoints = resp.minPoints;
                loyaltyItem.minCents = resp.minCents;
                loyaltyItem.rate = resp.rate;
                loyaltyItem.accountStatus = resp.accountStatus;
            }
        }

        this.setState({
            loyaltyListData: loyaltyListData
        });
    };

    getLoyaltyArrayByID = (id) => {
        const { loyaltyListData } = this.state;
        let _arr = loyaltyListData.filter(item => (item.id === id));

        return _arr[0];
    };

    getSelectedLoyaltyArrayByID = (id) => {
        const { loyaltyPaymentMethod } = this.state;
        let _arr = loyaltyPaymentMethod.filter(item => (item.id === id));
        if (_arr.length === 0) { return null; }
        return _arr[0];
    };

    getOtherSufficientMethod = () => {
        const {
            formValue,
            paymentListData,
            onlineBankListData,
            loyaltyPaymentAmount,
            firstPaymentAmount,
            remainingAmount
        } = this.state;

        const {
            mainProps
        } = this.props;

        const combination = mainProps.appState.topUpData.paymentCombinationList.filter(item => item.paymentMethod === formValue.paymentType);

        let allowedCombinationArr = null;
        if (combination !== undefined && combination[0] !== undefined) {
            if (combination[0].maxCombination <= 1) {
                return [];
            }
            allowedCombinationArr = combination[0].allowedCombination.paymentMethods;
        }

        const otherPaymentList = [];
        if (loyaltyPaymentAmount === 0) {
            const paymentList = paymentListData.filter(item => {
                const paymentBalance = isNaN(+item.balance) ? 9999999 : +item.balance;
                return ((item.id !== formValue.paymentType) && item.id !== PaymentType.ONLINEBANK && (paymentBalance >= remainingAmount) && (allowedCombinationArr === null || allowedCombinationArr.includes(!!isCreditCard(item.id) ? PaymentType.CARD : item.id)));
            });
            otherPaymentList.push(...paymentList);
    
            onlineBankListData.forEach(item => {
                if ((item.id !== formValue.paymentType) && (allowedCombinationArr === null || allowedCombinationArr.includes(item.id))) {
                    otherPaymentList.push(item);
                }
            });
        }

        return otherPaymentList;
    };

    selectSecondaryPaymentMethod = (e, item) => {
        const id = item.id;
        const {
            formValue,
            secondaryPaymentMethod,
            loyaltyPaymentMethod
        } = this.state;

        const { actionHandler, mainProps } = this.props;

        const offsetLeft = 10; // NOTE: need to figure out how to get this 20px
        const currentTarget = e.currentTarget;
        const itemStartXPos = currentTarget.offsetLeft - offsetLeft;
        const itemEndXPos = itemStartXPos + currentTarget.getBoundingClientRect().width;

        if(itemEndXPos > this.scrollerRef.getContainerWidth()) {
            // NOTE: if item exceeded right side container
            this.scrollerRef.scrollLeftTo(itemStartXPos);
        }

        if(itemStartXPos < this.scrollerRef.getCurrentScrollX()) {
            // NOTE: if item exceeded left side container
            this.scrollerRef.scrollLeftTo(itemStartXPos);
        }

        const curSelectedAmount = +(this.getArrayByID(formValue.paymentType).balance);
        if(curSelectedAmount === 0) {
            this.onSelectInputHandler(id);
            this.setState({
                secondaryPaymentMethod: '',
            }, () => {
                this.checkForm();
            });
        } else {
            this.setState({
                secondaryPaymentMethod: (secondaryPaymentMethod === id ? '' : id)
            }, () => {
                this.checkForm();
            });
        }
    };

    generateOtherPaymentMethodList = (item, key) => {
        const { secondaryPaymentMethod } = this.state;
        const { mainProps } = this.props;

        return (
            <li key={key} onClick={(e) => this.selectSecondaryPaymentMethod(e, item)}>
                <div className={[
                    'method-clicker',
                    (secondaryPaymentMethod === item.id ? ' selected' : '')
                ].join('')} data-id={ item.id }>
                    <div className="icon">
                        <div className="a">{ item.icon }</div>
                        <div className="b"><img src={PrestoAppTheme.images.CheckIcon.src} alt="Checked" /></div>
                    </div>
                    { !!isCreditCard(item.id) ? (
                        <React.Fragment>
                            <div className="name">{ 'My Card' }</div>
                            <div className="amount">{ item.label }</div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div className="name">{item.label}</div>
                            {!isNaN(+item.balance) && (
                                <div className="amount">{mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(item.balance / 100)}</div>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </li>
        )
    };

    onInputStateChangeHandler = (val, elmName) => {
        this.setState({
            formValue: {
                ...this.state.formValue,
                [elmName]: val
            }
        });
        setTimeout(() => {
            this.checkForm();
        }, 0);
    };

    onPinNumberChangeHandler = (val) => {
        this.setState({
            formValue: {
                ...this.state.formValue,
                pinNumber: val
            }
        });
        setTimeout(() => {
            this.checkForm();
        }, 0);
    };

    onSelectInputHandler = (val, submit) => {
        const { mainProps, actionHandler } = this.props;
    	const { loyaltyPaymentAmount, loyaltyPaymentMethod } = this.state;

        const amountToPay = +mainProps.appState.topUpData.amount - loyaltyPaymentAmount;
        const firstPaymentBalance = +(this.getArrayByID(val).balance);
        const firstPaymentAmount = mainProps.appState.isGuest || (!isPrestoPayMethod(val) && !isLoyaltyPayMethod(val) )
            ? amountToPay
            : firstPaymentBalance > amountToPay ? amountToPay : firstPaymentBalance;
        const remainingAmount = +(amountToPay - firstPaymentAmount).toFixed(2);

    	const normalizedPaymentType = isCreditCard(val) ? PaymentType.CARD : val;

	    const paymentData = mainProps.appState.paymentData;
	    const isAuthRequiredForPaymentType = paymentData.paymentCombinationList.some(combination =>
	        combination.paymentMethod === normalizedPaymentType && combination.authRequired === true
	    );

	    const isAuthRequiredForLoyalty = loyaltyPaymentMethod.some(item => {
	        const combination = paymentData.paymentCombinationList.find(combo => combo.paymentMethod === item.id);
	        return combination && combination.authRequired === true;
	    });
	
	    const isAuthRequired = amountToPay === 0 && !isAuthRequiredForLoyalty 
	        ? false 
	        : isAuthRequiredForPaymentType || isAuthRequiredForLoyalty;

        this.setState({
            formValue: {
                ...this.state.formValue,
                paymentType: val,
                otpNumber: '',
                pinNumber: '',
            },
            amountToPay,
            firstPaymentAmount,
            remainingAmount,
            secondaryPaymentMethod: '',
            isAuthRequired
        });
        setTimeout(() => {
            this.setState({ clearField: true },
                () => this.setState({ clearField: false })
            ); // NOTE: only to trigger clear text field
            this.checkForm();
            if (submit) {
                this.doSubmit();
            }
        }, 0);
    };

    doSubmit = () => {
        const {
            formValue,
            form2FATryCount,
            loyaltyPaymentMethod,
            secondaryPaymentMethod,
            loyaltyPaymentAmount,
            firstPaymentAmount,
            remainingAmount,
        } = this.state;
        const {
            mainProps,
            actionHandler,
        } = this.props;

        actionHandler.setIsVerifying(true);

        this.setState({
            isFormTouched: true,
            form2FATryCount: form2FATryCount + 1,
        });

        const topUpData = mainProps.appState.topUpData;
        const paymentData = mainProps.appState.paymentData;
        const loginData = mainProps.appState.loginData;

        /* NOTE: Create payments array list */
        const payments = [];

        if(loyaltyPaymentAmount !== 0) {
            loyaltyPaymentMethod.forEach((item, key) => {
                payments.push({
                    paymentMethod: item.id,
                    amount: item.amount,
                    paymentSubMethod: '',
                    paymentSubMethodRef: '',
                });
            });
        }

        if (firstPaymentAmount !== 0) {
            payments.push({
                paymentMethod: !!isCreditCard(formValue.paymentType) ? PaymentType.CARD : formValue.paymentType,
                amount: firstPaymentAmount,
                paymentSubMethod: this.getArrayByID(formValue.paymentType).cardProvider || '',
                paymentSubMethodRef: this.getArrayByID(formValue.paymentType).cardReference || '',
            });
        }

        if(secondaryPaymentMethod !== '') {
            payments.push({
                paymentMethod: !!isCreditCard(secondaryPaymentMethod) ? PaymentType.CARD : secondaryPaymentMethod,
                amount: remainingAmount,
                paymentSubMethod: this.getArrayByID(secondaryPaymentMethod).cardProvider || '',
                paymentSubMethodRef: this.getArrayByID(secondaryPaymentMethod).cardReference || '',
            });
        }

        const additionalData = {
            prestoPayObj: window.PrestoPayObj,
            paymentData: paymentData,
            loginData: mainProps.appState.loginData
        }

        appService.apiTopUpAuthorise({
            paymentCode: window.PrestoPayObj.paymentCode,
            loginMethod: loginData.loginMethod,
            mobileNum: loginData.mobile,
            mobileCountryCode: loginData.mobileCountryCode,
            email: loginData.email,
            password: loginData.password,
            authCode: window.PrestoPayObj.authCode,
            payments: payments,
            txnPin: formValue.pinNumber,
            paymentRefNum: topUpData.paymentRefNum,
            userRefNum: topUpData.userInfo.userRefNum,
            additionalData: encryptData(JSON.stringify(additionalData), topUpData.paymentRefNum),
            onSuccess: this.onSubmitSuccessHandler,
            onError: this.onSubmitFailedHandler,
        });
    };

    onSubmitHandler = (e) => {
        e.preventDefault();
        this.doSubmit();
    };

    onSubmitSuccessHandler = (resp) => {
        const { actionHandler } = this.props;
        if (!!resp.success) {
            if (resp.data.paymentStatus === 'PendingRedirect') {
                // NOTE: is using card, and needs 3DS flow
                this.setState({
                    allowShow3DSForm: true
                }, () => {
                    const form3ds = this.form3DSRef.current;
                    form3ds.action = resp.data.redirectUrl;
                    form3ds.method = 'post';

                    const redirectData = resp.data.redirectParams;
                    Object.keys(redirectData).forEach((key) => {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.setAttribute('name', key);
                        input.setAttribute('value', redirectData[key]);
                        form3ds.appendChild(input);
                    });
                    form3ds.submit();
                });
            } else {
                // NOTE: is standard flow
                actionHandler.setIsVerifying(false);
                /** NOTE:
                 * Set verify false here because
                 * 3DS flow needs this to be true to avoid prompt to leave site
                 */
                actionHandler.updateTopUpData(resp.data);
                actionHandler.changePageHandler(Routes.TOPUP_SUCCESS);
            }

        }
    };

    onSubmitFailedHandler = (data) => {
        const {
            actionHandler,
        } = this.props;

        console.log(data);

        actionHandler.setIsVerifying(false);

        switch (+data.errorCode) {
            case ErrorCode.INVALID_TRANSACTION_PIN:
            case ErrorCode.TRANSACTION_PIN_NOT_SET:
                this.setState({
                    formValue: {
                        ...this.state.formValue,
                        pinNumberError: true,
                    }
                });
                break;
            case ErrorCode.INVALID_PAYMENT_STATUS:
                this.setState({
                    isFormError: true,
                    dialog: {
                        show: true,
                        title: TopUpMessages.InvalidStatus.title,
                        message: TopUpMessages.InvalidStatus.message,
                        onClose: this.onCloseDialogHandler,
                    }
                });
                break;
            case ErrorCode.WEB_PAYMENT_LIMIT_REACHED:
                this.setState({
                    isFormError: true,
                    dialog: {
                        show: true,
                        title: TopUpMessages[PaymentStatus.LIMIT_REACHED].title,
                        message: TopUpMessages[PaymentStatus.LIMIT_REACHED].message,
                        onClose: this.onCloseDialogHandler,
                    }
                });
                break;
            case ErrorCode.SESSION_TIMEOUT:
                this.setState({
                    isFormError: true,
                    dialog: {
                        show: true,
                        title: TopUpMessages[PaymentStatus.EXPIRED].title,
                        message: TopUpMessages[PaymentStatus.EXPIRED].message,
                        onClose: this.onCloseDialogHandler,
                    }
                });
                break;
            default:
                this.setState({
                    isFormError: true,
                    dialog: {
                        show: true,
                        title: TopUpMessages.DefaultError.title,
                        message: TopUpMessages.DefaultError.message,
                        onClose: this.onCloseDialogHandler,
                    }
                });
        }
    };

    getArrayByID = (id) => {
        const { paymentListData, onlineBankListData } = this.state;
        let _arr1 = paymentListData.filter(item => (item.id === id));
        let _arr2 = onlineBankListData.filter(item => (item.id === id));

        return _arr1[0] ? _arr1[0] :
            (_arr2[0] ? _arr2[0] : {
                id: id,
                label: id,
                icon: "",
                iconHover: "",
                balanceID: "",
                loyalty: false,
                balance: 0
            });
    };

    determineIntialPaymentType = (paymentList, amount) => {
        const { loyaltyPaymentMethod } = this.state;
        if (paymentList.length === 1) {
            return paymentList[0].id;
        } else if (paymentList.length > 1) {
            // NOTE: get primary card
            let primaryCard = paymentList.filter(item => (item.id.startsWith(PaymentType.CARD + '_') && item.isPrimary));

            // NOTE: get non  primary card
            let nonPrimaryCard = paymentList.filter(item => (item.id.startsWith(PaymentType.CARD + '_') && !item.isPrimary));

            // NOTE: others
            let otherItems = paymentList.filter(item => (
                !item.id.startsWith(PaymentType.CARD + '_'))
            );

            let goRewardsSelected = loyaltyPaymentMethod.filter(item => (item.id === PaymentType.GOREWARDS));
            // NOTE: get TouchNGoEWallet item
            let tngEWalletItem = paymentList.filter(item => (item.id === PaymentType.TNGEWALLET));

            let paymentId = null;
            if (goRewardsSelected.length > 0 && tngEWalletItem.length > 0) {
                paymentId = PaymentType.TNGEWALLET;
            } else if (primaryCard && primaryCard.length > 0) {
                paymentId = primaryCard[0].id;
            } else if (nonPrimaryCard && nonPrimaryCard.length > 0) {
                paymentId = nonPrimaryCard[0].id;
            } else if (otherItems.length > 0) {
                paymentId = otherItems[0].id;
            }

            return paymentId;
        } else {
            return null;
        }
    };

    sortPaymentList = (obj) => {
        const { paymentListData } = this.state;

        if (paymentListData.length > 0) {
            // NOTE: already sorted
            return;
        }

        const otherPaymentArr = [];

        for (let item in obj) {
            otherPaymentArr.push(obj[item]);
        }

        if (otherPaymentArr.length > 0) otherPaymentArr.sort((a, b) => a.sortOrder - b.sortOrder);

        return [
            ...otherPaymentArr,

        ];
    };

    checkForm = () => {
        const {
            formValue,
            isFormTouched,
            remainingAmount,
            loyaltyPaymentAmount,
            isAuthRequired
        } = this.state;

        if(remainingAmount > 0) {
            // NOTE: is insufficient balance
            if (loyaltyPaymentAmount > 0) {
                // NOTE: loyalty already selected
                this.setState({
                    otherPaymentMethod: this.getOtherSufficientMethod()
                }, () => {
                    this.setState({
                        formValue: {
                            ...this.state.formValue,
                            paymentTypeError: true,
                        }
                    });
                });
            } else {
                this.setState({
                    otherPaymentMethod: this.getOtherSufficientMethod()
                }, () => {
                    this.setState({
                        formValue: {
                            ...this.state.formValue,
                            paymentTypeError: true,
                        }
                    });
                });
            }

        } else {
            this.setState({
                formValue: {
                    ...this.state.formValue,
                    paymentTypeError: false,
                }
            });
        }

        if(isFormTouched) {
            this.setState({
                formValue: {
                    ...this.state.formValue,
                    pinNumberError: (formValue.pinNumber === ''),
                    otpNumberError: (formValue.otpNumber === '')
                }
            });
        }

        setTimeout(() => {
            const { formValue, secondaryPaymentMethod, amountToPay } = this.state;
            const { mainProps } = this.props;
            const topUpData = mainProps.appState.topUpData;

            this.setState({
                isFormError: (
                    (formValue.paymentType === '' && amountToPay !== 0)
                    ||
                    (
                        (isAuthRequired) &&
                        (
                            (formValue.pinNumber === ''
                            ) ||
                            (formValue.pinNumber.length < 6
                            ) ||
                            (formValue.paymentTypeError && (secondaryPaymentMethod === '' && amountToPay !== 0))
                        ))
                )
            });
        }, 0);
    };

    onGoBack = () => {
        const { actionHandler, mainProps } = this.props;
        actionHandler.setIsLoading(true);

        appService.apiTopUpCancel({
            paymentCode: window.PrestoPayObj.paymentCode,
            paymentRefNum: mainProps.appState.topUpData.paymentRefNum,
            onSuccess: this.onTopUpCancelSuccessHandler,
            onError: this.onTopUpCancelFailedHandler,
        });

    }

    onTopUpCancelSuccessHandler = (resp) => {
        const { actionHandler } = this.props;
        const { goBackPage } = this.state;

        actionHandler.setIsLoading(false);
        actionHandler.changePageHandler(goBackPage);
    };

    onTopUpCancelFailedHandler = (data) => {
        const { actionHandler } = this.props;
        const { goBackPage } = this.state;

        actionHandler.setIsLoading(false);
        actionHandler.changePageHandler(goBackPage);
    };

    onCloseDialogHandler = () => {

        this.setState({
            goBackPage: Routes.PAYMENT,
            dialog: { show: false }
        }, () => {
            this.onGoBack();
        });
    };

    allowChangePaymentType = (val) => {
        const { loyaltyPaymentMethod } = this.state;
        let goRewardsSelected = loyaltyPaymentMethod.filter(item => (item.id === PaymentType.GOREWARDS));
        if (goRewardsSelected.length > 0 && PaymentType.TNGEWALLET === val) {
            this.setState({
                dialog: {
                    show : true, 
                    title: phrase_goRewardSeclected,
                    message: phrase_goRewardCombinationMessage,
                    onClose: this.onDialogModalHandler,
                }
            });
            return false;
        }
        return true;
    };

    onDialogModalHandler = () => {
        this.setState({
            dialog: {
                show : false, 
                title: '',
                message: '',
                onClose: null,
            }
        });
    };

    render() {
        const { mainProps } = this.props;
        const { isAuthRequired } = this.state;
        const {
            isFormError,
            clearField,
            formValue,
            paymentListData,
            onlineBankListData,
            loyaltyListData,
            otherPaymentMethod,
            loyaltyPaymentMethod,
            secondaryPaymentMethod,
            loyaltyPaymentAmount,
            amountToPay,
            firstPaymentAmount,
            remainingAmount,
            allowShow3DSForm,
            dialog,
        } = this.state;

        const topUpData = mainProps.appState.topUpData;

        const curPaymentMethod = !!isCreditCard(formValue.paymentType)
            ? this.getArrayByID(formValue.paymentType).label
            : (PaymentTypeInfo[formValue.paymentType] !== undefined ? PaymentTypeInfo[formValue.paymentType].label : this.getArrayByID(formValue.paymentType).label);

        return (
            <PageWrapper containerHeight={300} showPoweredByPresto={false}>
                <TopUpPaymentWrapper className="topup-payment">
                    <div className="details">
                        <div className="title">
                            <div className="back-btn" onClick={this.onGoBack}></div>
                            <div className="label">CREDITS TOP UP</div>
                        </div>
                        <div className="topup-amount">
                            {mainProps.appState.curCode.currency}{PrestoAppUtils.convertToCurrency(topUpData.amount / 100)}
                        </div>
                    </div>

                    {!!allowShow3DSForm && <form ref={this.form3DSRef} className="form-3ds"></form>}

                    <div className="payment-component">
                        { (!!loyaltyListData && loyaltyListData.length > 0) && (
                            <React.Fragment>
                                <div className="payment-method">
                                    <div className="payment-method-label">{term_useLoyaltyPoints}</div>

                                    <LoyaltyTypeMultiSelector
                                        appState={mainProps.appState}
                                        paymentData={mainProps.appState.topUpData}
                                        amountToPay={amountToPay}
                                        loyaltyList={loyaltyListData}
                                        selectedList={loyaltyPaymentMethod}
                                        onSelectAdd={this.onAddLoyaltyMethod}
                                        onSelectRemove={this.onRemoveLoyaltyMethod}
                                        onRevalidate={this.onRevalidateLoyaltyMethod}
                                    />
                                </div>
                            </React.Fragment>
                        )}
                        { (!!paymentListData && paymentListData.length > 0) && (
                            <div className="payment-method">
                                <div className="payment-method-label">{term_topUpUsing}</div>
                                <PaymentTypeSelector
                                    appState={mainProps.appState}
                                    paymentList={paymentListData}
                                    onlineBankList={onlineBankListData}
                                    onSelectInput={this.onSelectInputHandler}
                                    allowToggle={this.allowChangePaymentType}
                                    disabled={loyaltyPaymentAmount === +mainProps.appState.topUpData.amount}
                                    amountToPay={amountToPay}
                                    selectedIndex={formValue.paymentType}
                                    showError={formValue.paymentTypeError && secondaryPaymentMethod === ''}
                                    errorMessage={
                                        ( otherPaymentMethod.length > 0 ? (
                                            <React.Fragment>
                                                <div className="title">{ phrase_InsufficientBalance.hasOtherPayments.title }</div>
                                                <div className="message">{ phrase_InsufficientBalance.hasOtherPayments.message(
                                                    mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(+remainingAmount / 100)
                                                ) }
                                                </div>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                <div className="title">{ phrase_InsufficientBalance.noOtherPayments.title }</div>
                                                <div className="message">{ phrase_InsufficientBalance.noOtherPayments.message(
                                                    mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(+remainingAmount / 100)
                                                ) }
                                                </div>
                                            </React.Fragment>
                                        ))
                                    }
                                />
                            </div>
                        ) }

                        { (!!formValue.paymentTypeError && otherPaymentMethod.length > 0) && (
                            <div className="other-payment-method">
                                <HorizontalScroller
                                    onRef={ref => (this.scrollerRef = ref)}
                                    height={PaymentMethodBlockHeight}
                                    // scrollHandler={(e) => console.log(e, 'Scrolling!')}
                                >
                                    { otherPaymentMethod.length > 0 && (
                                        <ul>
                                            {otherPaymentMethod.map((item, key) => (
                                                this.generateOtherPaymentMethodList(item, key)
                                            ))}
                                        </ul>
                                    )}
                                </HorizontalScroller>
                            </div>
                        )}

                        { (!!paymentListData && paymentListData.length > 0 && (secondaryPaymentMethod !== '' || loyaltyPaymentMethod.length > 0)) && (
                            <React.Fragment>
                                <h3>{title_selectedPayment}</h3>
                                <div className="selected-payment">
                                    { loyaltyPaymentMethod.map((item, key) => {
                                        return (
                                            <div className="payment-row" key={key}>
                                                <div className="label">{this.getLoyaltyArrayByID(item.id).label}</div>
                                                <div className="value">{
                                                    mainProps.appState.curCode.currency + (PrestoAppUtils.convertToCurrency(+item.amount / 100) || 0)
                                                }</div>
                                            </div>
                                        );
                                    })}
                                    { (firstPaymentAmount > 0) && (
                                        <div className="payment-row">
                                            <div className="label">{curPaymentMethod}</div>
                                            <div className="value">{
                                                mainProps.appState.curCode.currency + (PrestoAppUtils.convertToCurrency(+firstPaymentAmount / 100) || 0)
                                            }</div>
                                        </div>
                                    )}
                                    { (secondaryPaymentMethod !== '') && (
                                        <div className="payment-row">
                                            <div className="label">{this.getArrayByID(secondaryPaymentMethod).label}</div>
                                            <div className="value">{
                                                mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(+remainingAmount / 100)
                                            }</div>
                                        </div>
                                    )}
                                    <div className="payment-row total">
                                        <div className="label">{term_totalAmount}</div>
                                        <div className="value">{
                                            mainProps.appState.curCode.currency + PrestoAppUtils.convertToCurrency(+topUpData.amount / 100)
                                        }</div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}

						<form className="payment-form">
						  {isAuthRequired && (
						    <>
						      <div className="payment-title">
						        {title_transactionPin}
						      </div>
						      <DigitInputWithLabel
						        initialValue=""
						        length={6}
						        inputName="pinNumber"
						        type="password"
						        onChange={this.onPinNumberChangeHandler}
						        errorMessage={phrase_PINErrorMessage}
						        clearField={clearField}
						        isError={formValue.pinNumberError}
						      />
						    </>
						  )}
                            <PrestoAppComponents.Button
                                height={ButtonHeight+'px'}
                                className="topup-button"
                                disabled={isFormError}
                                onClick={this.onSubmitHandler}
                            >{term_topUp}</PrestoAppComponents.Button>

                        </form>

                        {dialog.show && (
                            <LoyaltyMessageModal
                                isOpen={ dialog.show }
                                title= { dialog.title }
                                message= { dialog.message }
                                onClose={ dialog.onClose }
                            />
                        )}

                        <PoweredByPresto />
                    </div>
                </TopUpPaymentWrapper>
            </PageWrapper>
        );
    }
}

export default connectPage(TopUpPayment);


const TopUpPaymentWrapper = styled.div`
    min-height: 100px;

    & .details {
        display: flex;
        justify-content: center;
        flex-direction: column;
        color: ${PrestoAppTheme.colors.baseGreyDark};
        padding-bottom: 4.125rem; 
        background: url("/resources/images/topup-options-bg.png") right center / 160px no-repeat;

        & .title {
            display: flex;
            align-items: center;
            margin: ${PrestoAppTheme.layout.smallGap};

            & .back-btn {
                border: solid ${PrestoAppTheme.colors.baseGreyDark};
                border-width: 0 3px 3px 0;
                display: inline-block;
                padding: 3px;
                width: 3px;
                height: 3px;
                transform: rotate(135deg);
                cursor: pointer;
            }

            & .label { 
                flex-grow: 1;
                text-align: center;
                text-transform: uppercase;
                font-size: ${PrestoAppTheme.layout.fontSizeStandard};
                font-weight: 400;
            }
        }

        & .topup-amount {
            margin: ${PrestoAppTheme.layout.smallGap};
            font-size: 1.75rem;
            font-weight: 500;
            text-align: center;
        }
    }

    & .form-3ds {
        display: none;
    }

    & .payment-component {
        padding: ${PrestoAppTheme.layout.smallGap};
        background-color: #FEF3E2;
        margin-top: -3.063rem;
        border-radius: 10px 10px ${PrestoAppTheme.layout.borderRadius} ${PrestoAppTheme.layout.borderRadius};

        & .payment-method {
            margin-bottom: ${PrestoAppTheme.layout.smallGap};        
        
            & .payment-method-label {
                margin-bottom: ${PrestoAppTheme.layout.smallGap};
                color: ${PrestoAppTheme.colors.baseGreyDark};
                font-weight: 500;
            }

            & .payment-type-selector {
                background-color: ${PrestoAppTheme.colors.white};
            }

            & .loyalty-type-multi-selector {
                background-color: ${PrestoAppTheme.colors.white};
            }
            
        }

        & .other-payment-method {
            margin: ${PrestoAppTheme.layout.smallGap} 0 1.8rem 0;

            & ul {
                // display: flex;
                padding: 0;
                margin: 0;
                list-style: none;
                // flex-wrap: wrap;
                // justify-content: space-between;

                & > li {
                    display: inline-block;
                    width: calc(35% - ${PrestoAppTheme.layout.smallGap});
                    margin-right: ${PrestoAppTheme.layout.smallGap};
                    vertical-align: top;
                    background-color: ${PrestoAppTheme.colors.white};
                    @media only screen and (max-width: 768px) {
                        width: calc(45% - ${PrestoAppTheme.layout.smallGap});
                    }
                    @media only screen and (max-width: 320px) {
                        width: calc(55% - ${PrestoAppTheme.layout.smallGap});
                    }

                    &:last-child {
                        margin-right: 0;
                    }

                    & .method-clicker {
                        height: ${PaymentMethodBlockHeight}px;
                        padding: ${PrestoAppTheme.layout.smallGap};
                        border: 1px solid ${PrestoAppTheme.colors.baseSnowDark};
                        border-radius: ${PrestoAppTheme.layout.borderRadius};
                        box-sizing: border-box;
                        cursor: pointer;

                        & .icon {
                            height: 30px;
                            line-height: 30px;
                            max-width: 70px;
                            margin-bottom: ${PrestoAppTheme.layout.xSmallGap};

                            & img {
                                max-height: 30px;
                                max-width: 70px;
                            }

                            & .a {
                                display: block;
                            }

                            & .b {
                                display: none;
                            }
                        }
                        
                        & .amount {
                            font-weight: 500;
                        }

                        &.selected {       
                            border: 1px solid rgb(${PrestoAppTheme.colors.prestoRedRGB});
                        }
                    }
                }
            }
        }

        & .selected-payment {
            & .payment-row { 
                display: flex;
                width: 100%;
                justify-content: space-between;
                line-height: 1.5rem;

                & .label {  }

                & .value { font-weight: 500; }

                &.total { 
                    border-top: 1px solid ${PrestoAppTheme.colors.baseSnowDark};
                    line-height: 2rem;
                    
                    & .value { 
                        color: rgb(${PrestoAppTheme.colors.prestoRedRGB});
                    }
                }
            }
        }

        & > h3 {
            margin: 2rem 0 ${PrestoAppTheme.layout.smallGap} 0;
            font-size: ${PrestoAppTheme.layout.fontSizeStandard};
            font-weight: 500;
        }

        & .topup-button {
            &[disabled] {
                background-color: rgba(${PrestoAppTheme.colors.prestoRedRGB}, .4);
            }
        }

        & .payment-form {
            
        }

        & .payment-title {
            font-weight: 500;
        }
    }
`;